import { render, staticRenderFns } from "./ReviewTagsSettingsController.vue?vue&type=template&id=795353f0&scoped=true&"
import script from "./ReviewTagsSettingsController.vue?vue&type=script&lang=js&"
export * from "./ReviewTagsSettingsController.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTagsSettingsController.vue?vue&type=style&index=0&id=795353f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795353f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
